module.exports = "/_next/static/images/location-1152be466d768bd1c8982ef4ef20277d.svg";